export default function update(
    {folder}: UpdateFolderAction,
    setFolders: React.Dispatch<React.SetStateAction<{[localId: string]: Folder}>>
) {
    setFolders((latestFolders) => ({
        ...latestFolders,
        [folder.localId]: folder,
    }));
    return [folder.localId];
}
